import { Gift } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";

// Read-only gift rows (qty locked to 1, cannot be removed individually) + eligibility hint.
export default function GiftLines({ compact = false }) {
  const { promo, gifts, giftEligible } = useCart();
  const { t } = useLang();
  if (promo?.kind !== "gift") return null;

  if (!giftEligible) {
    return (
      <div data-testid="gift-hint" className="flex items-start gap-2 rounded-lg border border-dashed border-xd-orange/50 bg-orange-50 p-3 text-xs text-xd-text">
        <Gift className="w-4 h-4 text-xd-orange shrink-0" />
        <span>{t("promo_gift_hint").replace("{code}", promo.code).replace("{min}", Number(promo.min_item_price ?? 150).toFixed(0))}</span>
      </div>
    );
  }

  return (
    <div data-testid="gift-lines" className="space-y-2">
      {gifts.map((g) => (
        <div key={g.cart_key} data-testid={`gift-item-${g.product_id}`} className={`flex items-center gap-3 rounded-lg border border-emerald-200 bg-emerald-50/60 ${compact ? "p-2" : "p-3"}`}>
          <div className="w-12 h-12 rounded bg-white overflow-hidden shrink-0">{g.image && <img src={g.image} alt={g.name} className="w-full h-full object-cover" />}</div>
          <div className="flex-1 min-w-0 text-sm">
            <div className="font-medium leading-tight line-clamp-2">{g.name}</div>
            <div className="mt-0.5 inline-flex items-center gap-1 rounded bg-emerald-600 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white"><Gift className="w-3 h-3" /> {t("promo_gift_badge")} · {t("checkout_qty")} 1</div>
          </div>
          <div className="text-right">
            {g.list_price > 0 && <div className="text-[11px] text-xd-muted line-through">€ {g.list_price.toFixed(2)}</div>}
            <div className="text-sm font-semibold text-emerald-700">€ 0.00</div>
          </div>
        </div>
      ))}
    </div>
  );
}
